export type ResolveOutcome = 'CLOSED' | 'ABORTED';

export interface ResolveDealCostValues {
  outcome: ResolveOutcome;
  investment_fund_transaction_id: string;
  aborted_on: string;
}

export interface ResolveDealCostErrors {
  investment_fund_transaction_id?: string;
  aborted_on?: string;
}

/** A deal cannot resolve before its cost was paid. ISO dates compare as strings. */
export function isResolvableOn(resolvedOn: string, costDate: string): boolean {
  return resolvedOn >= costDate;
}

export function validateResolveDealCost(
  values: ResolveDealCostValues,
  costDate: string
): ResolveDealCostErrors {
  const errors: ResolveDealCostErrors = {};
  if (values.outcome === 'CLOSED' && !values.investment_fund_transaction_id) {
    errors.investment_fund_transaction_id = 'Investment is required';
  }
  if (values.outcome === 'ABORTED' && !values.aborted_on) {
    errors.aborted_on = 'Date is required';
  } else if (
    values.outcome === 'ABORTED' &&
    !isResolvableOn(values.aborted_on, costDate)
  ) {
    errors.aborted_on = 'Cannot be before the cost was paid';
  }
  return errors;
}

export function hasAnyError(errors: ResolveDealCostErrors): boolean {
  return Object.keys(errors).length > 0;
}
